import { LogItem } from "@lhd/types";
import { PinMapPlusIcon } from "@lhd/assets";
import { Styles } from "./styled";
import { ReactNode } from "react";

interface IProps {
  logtime: LogItem;
}

const formatLocation = (log: LogItem): ReactNode => {
  if (log.latitude != null && log.longitude != null) {
    return (
      <a
        href={`https://www.google.com/maps?q=${log.latitude},${log.longitude}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {log.log_type === "check_in" ? "出勤打刻場所" : "退勤打刻場所"}
      </a>
    );
  }
  return "-";
};

const LocationField = (props: IProps) => {
  const { logtime } = props;
  return (
    <Styles className="timeline-location">
      <PinMapPlusIcon />
      <span className="location-text">{formatLocation(logtime)}</span>
    </Styles>
  );
};

export default LocationField;
